import urls from '@/navigation/urls'
import { IIncidentSystemEvent, ISystemEvent } from '@/pages/SystemEvents/systemEvents.types.ts'
import { INotification, IUserNotification } from '@/services/Notification/notifications.types.ts'
import Button from '@/shared/Buttons/Button'
import { useNavigate } from 'react-router-dom'

interface IProps {
  notification: INotification | ISystemEvent
}

const NotificationCenterActions = (props: IProps) => {
  const navigate = useNavigate()
  switch (props.notification.type) {
    case 'ALARM_SITUATION_INCIDENT':
      return (
        <Button
          size="default"
          type="default"
          text="Перейти к устройству"
          onClick={() =>
            navigate(`/equipment/lifts/${(props.notification as IIncidentSystemEvent).payload.equipmentId}`)
          }
        />
      )
    case 'LIFT_ERROR':
      if ((props.notification as IUserNotification).metadata.equipmentIds?.length === 0) return null
      return (
        <Button
          size="default"
          type="default"
          text="Перейти к устройству"
          onClick={() =>
            navigate(`/equipment/lifts/${(props.notification as IUserNotification).metadata.equipmentIds[0]}`)
          }
        />
      )
    case 'MAINTENANCE_OVERDUE_FACT':
    case 'MAINTENANCE_OVERDUE_WARNING':
      return (
        <Button size="default" type="default" text="Показать в Календаре ТО" onClick={() => navigate(urls.calendar)} />
      )
    default:
      return null
  }
}

export default NotificationCenterActions
